"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.is-nan");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-float");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderColor: theme.borderColor,
    borderRadius: 2,
    fontSize: 13,
    padding: 5,
    color: theme.labelColor
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var NumberType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumberType, _React$Component);

  function NumberType(props) {
    var _this;

    _classCallCheck(this, NumberType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberType).call(this, props));

    _this.numberTransformer = function (x) {
      if (Number.isNaN(Number(x))) {
        return x.substr(0, x.length - 1);
      }

      return x;
    };

    _this.onChangeNormal = function (value) {
      var onChange = _this.props.onChange;

      if (!Number.isNaN(value)) {
        onChange(value);
      }
    };

    _this.renderNormal = _this.renderNormal.bind(_assertThisInitialized(_this));
    _this.renderRange = _this.renderRange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NumberType, [{
    key: "renderNormal",
    value: function renderNormal() {
      var knob = this.props.knob;
      return _react["default"].createElement(Input, {
        autoCapitalize: "none",
        underlineColorAndroid: "transparent",
        value: (knob.value || '').toString(),
        transformer: this.numberTransformer,
        keyboardType: "numeric",
        onChangeText: this.onChangeNormal
      });
    }
  }, {
    key: "renderRange",
    value: function renderRange() {
      var _this$props = this.props,
          knob = _this$props.knob,
          onChange = _this$props.onChange;
      return _react["default"].createElement(_reactNative.Slider, {
        value: knob.value,
        minimumValue: knob.min,
        maximumValue: knob.max,
        step: knob.step,
        onSlidingComplete: function onSlidingComplete(val) {
          return onChange(parseFloat(val));
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      return _react["default"].createElement(_reactNative.View, {
        style: {
          margin: 10
        }
      }, knob.range ? this.renderRange() : this.renderNormal());
    }
  }]);

  return NumberType;
}(_react["default"].Component);

NumberType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
NumberType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    step: _propTypes["default"].number,
    min: _propTypes["default"].number,
    max: _propTypes["default"].number,
    range: _propTypes["default"].bool
  }),
  onChange: _propTypes["default"].func
};

NumberType.serialize = function (value) {
  return String(value);
};

NumberType.deserialize = function (value) {
  return parseFloat(value);
};

var _default = NumberType;
exports["default"] = _default;